module.exports = __webpack_public_path__ + "static/original-mattress-intro-d39d3d7f46db69f301259093a4d6ed85.mp4";